import { Component, h } from 'preact'
import UserAvatar from '../User/UserAvatar'
import UserName from '../User/UserName'
import TopicVote from '../topic-list-view/TopicVote'
import TopicComments from '../topic-list-view/TopicComments'
import TopicLastPost from '../topic-list-view/TopicLastPost'
import htmlParser from '../utils/htmlParser'
import Axios from 'axios'
import IdeationStatus from '../topic-list-view/IdeationStatus'

type Person = {
  id: string,
  avatar: string,
  username: string,
  reputation: {
      repliesMade: number
  }
}
interface Props {
  contentType: string,
  id: string,
  title: string,
  content: string,
  publicLabel: string,
  tags: Array<string>,
  replyCount: number,
  votes: number,
  voteSet:Array<string>,
  likedBy: Array<string>,
  author: Person,
  lastContributor: Person,
  createdAt: string,
  lastActivityAt: string,
  isGuest: boolean,
  ideaStatus: {name: string, backgroundColor: string, textColor: string},
  currentUserId: number
}

interface State {
  votes: number,
  currentUserVoted: boolean,
}

const DateFormatter = (date: string) => {
  const createdDate = new Date(date)

  return (
    new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }).format(createdDate.getTime())
  )
}

class IdeaView extends Component<Props, State> {

  constructor (props: Props) {
    super(props)
    this.state = {
      votes: props.votes,
      currentUserVoted: props.currentUserId !== null && props.voteSet.includes(props.currentUserId.toString())
    }

    this.toggleVoteStatus = this.toggleVoteStatus.bind(this)
  }

  async toggleVoteStatus () {
    if (this.props.isGuest) {
      const event = new CustomEvent('GuestUserAction')
      window.dispatchEvent(event)
      return
    }

    if (this.state.currentUserVoted) {
      this.setState({ currentUserVoted: false, votes: this.state.votes - 1 })
      await Axios.post(`/community/api/ideas/${this.props.id}/unvote`)
    } else {
      this.setState({ currentUserVoted: true, votes: this.state.votes + 1 })
      await Axios.post(`/community/api/ideas/${this.props.id}/vote`)
    }
  }

  render (
    { isGuest, id, title, content, replyCount, lastActivityAt, lastContributor, author, ideaStatus }: Props,
    { votes, currentUserVoted }: State
  ) {
    const strippedContent = htmlParser.stripHtml(content)

    const ideaUrl = `/ideas/${title.toLowerCase().split(' ').join('-')}-${id}`

    return (
      <div className='topic-view topic-view--ideation idea-view'>
        <a href={ideaUrl} className='topic-view_link' />
        <div className='topic-view_header'>
          <div className='topic-view_header-item'>
            <UserAvatar
              user={{ ...author, ...{ name: author.username } }}
              extraClass='avatar'
              showRank
            />
          </div>
          <div className={'topic-view_header-items-gathered topic-view_header-items_without-category'}>
            <div className='topic-view_header-item'>
              <UserName
                user={author}
                extraClass='username'
              />
              {author.id && author.username ? <span className='user-title text--meta'>{ author.username }</span> : ''}
            </div>
          </div>
        </div>
        <div className='topic-view_info idea-view_info'>
          <div className='topic-view_body-container'>
            <div className='topic-view_body'>
              <h4 className='thread-list-block__title'>
                <a href={ideaUrl} className='qa-topic-title thread-list-block__title-link'>{ title }</a>
                <IdeationStatus topic={{ ideaStatus: ideaStatus }} />
              </h4>
              <p class='thread-list-block__content qa-topic-content'>
                <a href={ideaUrl}>
                  {strippedContent}
                </a>
              </p>
            </div>
            <div className='topic-view_footer'>

              <TopicVote
                currentUserVoted={currentUserVoted}
                numberOfVotes={votes}
                onClick={this.toggleVoteStatus}
              />
              <TopicComments
                numberOfReplies={replyCount}
                id={id}
                lastPostUrl='/'
              />
              <TopicLastPost
                lastPostAuthor={{ ...lastContributor, name: lastContributor.username }}
                lastPostUrl='/'
                lastPostRelativeCreationDate={DateFormatter(lastActivityAt)}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default IdeaView
